<script setup>
defineProps({
  image: {
    type: String,
    required: true
  },
  reverse: {
    type: Boolean,
    default: false
  }
});

</script>
<template>

  <div :class="['max-w-8xl mx-auto flex flex-col md:flex-row items-center gap-25', reverse ? 'md:flex-row-reverse' : '']">

    <div class="w-full flex justify-center">
      <img
          :src="image"
          alt="About Image"
          class="w-full max-w-[350px] sm:max-w-[500px] h-auto object-contain"
      />
    </div>

    <div class="w-full flex justify-center sm:justify-start">
      <div class="w-full max-w-[350px] sm:max-w-[500px] text-left space-y-7.5">
        <hr class="w-1/4 h-0.5 bg-primary-violet border-0">
        <p class="responsive-title-3">
          <slot name="title" />
        </p>
        <p class="responsive-body-large">
          <slot name="content" />
        </p>
      </div>
    </div>

  </div>


</template>


